<template>
    <div id="fleet-overview">
        <h2>{{ $t('dashboard.fleetOverview.header') }}</h2>
        <ul>
            <li :class="['status-online', { active: isAvailable(online) } ]" @click="updateFilters(online)">
                <div class="status-text">{{ $t('dashboard.fleetOverview.driving') }}</div>
                <div class="status-amount">{{ getDevicesOnline }}</div>
            </li>
            <li :class="['status-offline', { active: isAvailable(offline) } ]" @click="updateFilters(offline)">
                <div class="status-text">{{ $t('dashboard.fleetOverview.offline') }}</div>
                <div class="status-amount">{{ getDevicesOffline }}</div>
            </li>
            <li :class="['status-sleep no-after', { active: isAvailable(inactive) } ]" @click="updateFilters(inactive)">
                <div class="status-text">{{ $t('dashboard.fleetOverview.sleep') }}</div>
                <div class="status-amount">{{ getDevicesInactive }}</div>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { VEHICLE_INACTIVE, VEHICLE_OFFLINE, VEHICLE_ONLINE } from '@/config/tackingConfig';

export default {
    name: 'FleetOverview',
    props: {
    },
    mounted () {
    },
    data () {
        return {
            online: VEHICLE_ONLINE,
            offline: VEHICLE_OFFLINE,
            inactive: VEHICLE_INACTIVE,
        }
    },
    computed: {
        ...mapGetters({
            getDevicesInactive: 'trackingModule/getDevicesInactive',
            getDevicesOnline: 'trackingModule/getDevicesOnline',
            getDevicesOffline: 'trackingModule/getDevicesOffline',
            getFilters: 'trackingModule/getFilters'
        })
    },
    methods: {
        ...mapActions({
            updateFilters: 'trackingModule/updateFilters'
        }),
        isAvailable (status) {
            return this.getFilters.includes(status)
        }
    }
}
</script>

<style lang="scss">
#fleet-overview {
    background: $dark;
    border-left: get($left-border, width) solid $primary;
    padding-top: 37px;
    padding-bottom: 51px;

    h2 {
        margin: 0;
        padding-left: 45px;
    }

    ul {
        list-style: none;

        li {
            margin-top: 5px;
            cursor: pointer;

            &::before {
                content: '';
                display: inline-block;
                width: 15px;
                height: 15px;
                border-radius: 50%;
                border: 3px solid red;
                background: transparent;
                position: relative;
                top: 3px;
            }

            &.active {
                &::before {
                    background: red;
                }
            }

            &::after {
                content: '';
                width: 1px;
                height: 15px;
                background: #707070;
                display: block;
                position: relative;
                top: 4px;
                left: 7px;;
            }

            &.no-after {
                &::after {
                    display: none;
                }
            }

            .status-text {
                display: inline-block;
                width: 97px;
                margin-left: 19px;
            }

            .status-amount {
                display: inline-block;
            }

            &.status-online {
                &::before {
                    border-color: $success;
                }

                &.active {
                    &::before {
                        background: $success;
                    }
                }

                .status-amount {
                    color: $success;
                }
            }

            &.status-offline {
                &::before {
                    border-color: $danger;
                }

                &.active {
                    &::before {
                        background: $danger;
                    }
                }

                .status-amount {
                    color: $danger;
                }
            }

            &.status-sleep {
                &::before {
                    border-color: $inactive;
                }

                &.active {
                    &::before {
                        background: $inactive;
                    }
                }

                .status-amount {
                    color: $inactive;
                }
            }
        }
    }
}
</style>
